class CodeData {
  email?: string;
  code?:string;
}

export default CodeData
